<template>
  <div id="app">
    <div class="wrap">
      <transition name="fade">
        <div
          v-if="showPoster"
          class="poster"
        >
          <PlayButton @play="start" />
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="showControlButtons"
          class="poster"
          @click.self="controlsClick"
        >
          <PrevButton class="prev" @prev="toStartOfChapter" />
          <PauseButton v-if="isPlaying" @pause="pausePlayers" />
          <PlayButton v-else @play="playPlayers" />
          <NextButton class="next" @prev="toEndOfChapter" />
        </div>
      </transition>
      <Choices
        v-if="showChoiceButtons && currentSection && currentSection.choices"
        :choices="currentSection.choices"
        :mode="currentSection.choiceMode"
        @buttonClick="goToSection"
      />
      <div class="video-holder">
        <video
          :src="require('@/assets/instanieuwsuur_HetNieuweGamenV6.mp4')"
          class="main-video"
          playsinline
          preload="auto"
          ref="video"
          :poster="require('@/assets/poster.jpg')"
          @timeupdate="timeUpdateHandler"
          @click="videoClick"
        />
        <video
          v-if="!isIE"
          :src="require('@/assets/instanieuwsuur_HetNieuweGamenV6.mp4')"
          class="bg-video"
          playsinline
          preload="auto"
          ref="bg"
          muted
        />
      </div>
    </div>
  </div>
</template>

<script>
import 'reset-css'
import PrevButton from '@/components/PrevButton'
import PlayButton from '@/components/PlayButton'
import PauseButton from '@/components/PauseButton'
import NextButton from '@/components/NextButton'
import Choices from '@/components/Choices'

export default {
  name: 'app',
  data () {
    const sections = [{
      handle: 'intro',
      start: 0,
      end: 28,
      choiceSeconds: 4,
      choices: ['mario-intro', 'casino-intro', 'treatment-intro']
    }, {
      handle: 'mario-intro',
      start: 29.5,
      end: 100,
      choiceSeconds: 16,
      choices: ['mario-cijfers', 'mario-expert']
    }, {
      handle: 'mario-expert',
      start: 101.8,
      end: 224,
      choiceSeconds: 16,
      choiceMode: 'chapter',
      choices: ['casino-intro', 'mario-cijfers', 'treatment-intro']
    }, {
      handle: 'mario-cijfers',
      start: 226,
      end: 308,
      choiceSeconds: 16,
      choiceMode: 'chapter',
      choices: ['casino-intro', 'mario-expert', 'treatment-intro']
    }, {
      handle: 'casino-intro',
      start: 309.9,
      end: 408,
      choiceSeconds: 16,
      choices: ['casino-whales', 'casino-lootboxes']
    }, {
      handle: 'casino-lootboxes',
      start: 410,
      end: 510,
      choiceSeconds: 16,
      choiceMode: 'triwave',
      choices: ['casino-whales', 'mario-intro', 'treatment-intro']
    }, {
      handle: 'casino-whales',
      start: 510.5,
      end: 606,
      choiceSeconds: 16,
      choiceMode: 'triwave',
      choices: ['casino-lootboxes', 'mario-intro', 'treatment-intro']
    }, {
      handle: 'treatment-intro',
      start: 606.5,
      end: 673,
      choiceSeconds: 16,
      choices: ['treatment-floris', 'treatment-jan-willem']
    }, {
      handle: 'treatment-floris',
      start: 673.5,
      end: 761,
      choiceSeconds: 16,
      choiceMode: 'triwave',
      choices: ['treatment-jan-willem', 'mario-intro', 'casino-intro']
    }, {
      handle: 'treatment-jan-willem',
      start: 761.8,
      end: 853,
      choiceSeconds: 16,
      choiceMode: 'triwave',
      choices: ['treatment-floris', 'mario-intro', 'casino-intro']
    }]

    return {
      isIE: !!window.MSInputMethodContext && !!document.documentMode,
      isPlaying: false,
      showPoster: true,
      showControlButtons: false,
      showChoiceButtons: false,
      currentSection: sections[0],
      sections
    }
  },
  computed: {
    player () {
      return this.$refs.video
    },
    bg () {
      return this.$refs.bg
    }
  },
  watch: {
    showChoiceButtons () {
      if (this.showChoiceButtons) {
        this.showControlButtons = false
      }
    },
    showControlButtons () {
      if (this.showControlButtons && this.isPlaying) {
        setTimeout(() => {
          if (this.isPlaying) {
            this.showControlButtons = false
          }
        }, 5000)
      }
    }
  },
  methods: {
    setTime (timestamp) {
      this.player.currentTime = timestamp

      if (!this.isIE) {
        this.bg.currentTime = timestamp
      }
    },
    start () {
      this.showPoster = false
      this.playPlayers()
    },
    pausePlayers () {
      this.isPlaying = false
      this.player.pause()

      if (!this.isIE) {
        this.bg.pause()
      }
    },
    playPlayers () {
      this.isPlaying = true
      this.showControlButtons = false
      this.player.play()

      if (!this.isIE) {
        this.bg.play()
      }
    },
    controlsClick () {
      if (this.isPlaying) {
        this.showControlButtons = false
      }
    },
    videoClick () {
      if (!this.showChoiceButtons) {
        this.showControlButtons = !this.showControlButtons
      }
    },
    toStartOfChapter () {
      const { start } = this.currentSection
      this.setTime(start)

      if (this.isPlaying) {
        this.showControlButtons = false
      }
    },
    toEndOfChapter () {
      const { end } = this.currentSection
      this.setTime(end)

      if (this.isPlaying) {
        this.showControlButtons = false
      }
    },
    goToSection (handle) {
      // Set currentSection
      this.currentSection = this.sections.filter(section => section.handle === handle)[0]

      // Set the player at the start of the new section
      const { start } = this.currentSection
      this.setTime(start)

      // Set to false before the time updates
      this.showChoiceButtons = false
      this.playPlayers()
    },
    timeUpdateHandler () {
      const currentTime = this.player.currentTime
      const { end, choiceSeconds } = this.currentSection
      const timeToChoose = end - choiceSeconds

      // Show or hide the choice buttons screen
      this.showChoiceButtons = currentTime >= timeToChoose

      // Loop video at the end
      if (currentTime >= end) {
        this.pausePlayers()
      }
    }
  },
  components: {
    PrevButton,
    PlayButton,
    PauseButton,
    NextButton,
    Choices
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;

  .play-button {
    transition: all 0.3s ease-out;
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;

  .play-button {
    opacity: 0.25;
    transform: translate(-50%, -50%) scale(0.5) !important;
  }
}

html,
body {
  min-height: 100%;
  height: 100%;
  background: #3a3a4a;
}

#app {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.wrap {
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.poster {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(#3a3a4a, 0.5);
  z-index: 20;
}

.prev {
  margin-left: -110px;
}

.next {
  margin-left: 110px;
}

.video-holder {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 1;
  overflow: hidden;
}

.main-video {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  outline: 0;
  z-index: 5;
  margin: 0 auto;
  max-width: 1400px;
}

.bg-video {
  filter: blur(50px);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
